import { useLocation } from "react-router-dom";

const useExploreInfo = () => {
  const location = useLocation();
  const entity_type = location.pathname.split("/")[2];
  const explore_slug = location.pathname.split("/")[3]; // was raw ID, now slug

  return {
    explore_slug,
    entity_type,
    unit_id: explore_slug,
    institution_id: explore_slug,
    venue_id: explore_slug,
    entity_id: explore_slug,
  };
};

export default useExploreInfo;
